import { render, staticRenderFns } from "./SearchHomePage.vue?vue&type=template&id=48ad5be8&"
import script from "./SearchHomePage.vue?vue&type=script&lang=js&"
export * from "./SearchHomePage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports